import { showModal } from 'actions/modals';

import { SHOW_Q2_TIER_CHANGE_MODAL } from 'features/modals/constants';

export const showQ2TierChangeModal = () =>
  showModal(SHOW_Q2_TIER_CHANGE_MODAL, { deprecatedModal: true });
